import {DateTime} from "luxon";
import {Polygon} from "geojson";
import {Zone} from "./Zone";
import {Floor, FloorData} from "./Floor";

export type Building = {
    id: number
    uuid: string
    reference: string | null
    provider: BuildingProvider | null
    name: string
    description: string | null
    zone_id: number
    zone: Zone
    footprint: Polygon
    additional_data: Record<string, any> | null
    floors: Floor[]
    created_at: DateTime
    updated_at: DateTime
}

export type BuildingData = {
    zone_id?: number
    name?: string
    description?: string | null
    footprint?: Polygon
    additional_data?: Record<string, any> | any[] | null
    reference?: string | null
    provider?: string | null
    floors?: FloorData[]
}

export enum BuildingProvider {
    NGAGE = 'ngage',
    SITUM = 'situm',
}